/*
 * `F-0b`: **« → » and « ✓ » as icons.** The bank's face is IBM Plex Sans in its Latin subset, which has neither
 * glyph (F-0a review), so a typed arrow or tick would fall back to another font mid-sentence. These are drawn,
 * decorative (`aria-hidden`: the words beside them carry the meaning) and sized to the text (`1em`).
 */
const SVG_PROPS = {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  width: "1em",
  height: "1em",
  "aria-hidden": "true",
  focusable: "false",
  className: "inline-block shrink-0 align-[-0.125em]",
} as const;

export function ArrowRightIcon(): React.JSX.Element {
  return (
    <svg {...SVG_PROPS}>
      <path d="M5 12h14M13 6l6 6-6 6" />
    </svg>
  );
}

export function CheckIcon(): React.JSX.Element {
  return (
    <svg {...SVG_PROPS}>
      <path d="M5 12.5l4.5 4.5L19 7.5" />
    </svg>
  );
}
